import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { User } from "../Model/User";

export async function getUser(id) {
	let response = await getAPIResponse("/v1/user/"+id);
	if (response === null) {
		return null;
	}
	let user = User.createFromResponseData(response);
	return user;
}